import { DeviceStatus } from './../enums/deviceStatus';
import { Device } from './../classes/device';
import { DeviceVm } from './../classes/deviceVm';
import { AppResponse } from 'modules/core/interfaces/appResponse';
import AuthorizedApiClient from 'modules/auth/models/authorizedApiClient';
import { AxiosResponse } from 'axios';
import store from '@/store/index';

export class DeviceApi {
  public MasterAccountId: string;

  public constructor() {
    this.MasterAccountId = store.state.auth && store.state.auth.user
    ? store.state.auth.user.MasterAccountId
    : null;
  }

  public async list(): Promise<DeviceVm[]> {
    const MasterAccountId = this.MasterAccountId;
    const response: AxiosResponse<
      AppResponse<DeviceVm[]>
    > = await AuthorizedApiClient.post('/device/getDevices', {
      MasterAccountId,
    });
    const appResponse: AppResponse<DeviceVm[]> = response.data;
    if (appResponse.IsSuccess) {
      const devices: DeviceVm[] = appResponse.Result ? appResponse.Result : [];
      return devices;
    } else {
      throw new Error(appResponse.ErrorCodes.join(','));
    }
  }

  public async get(phoneNr: string): Promise<DeviceVm> {
    const MasterAccountId = this.MasterAccountId;
    const response: AxiosResponse<
      AppResponse<DeviceVm>
    > = await AuthorizedApiClient.post('/device/getDevice', {
      PhoneNumber: phoneNr,
      MasterAccountId,
    });
    const appResponse: AppResponse<DeviceVm> = response.data;
    if (appResponse.IsSuccess) {
      const device: DeviceVm = appResponse.Result;
      return device;
    } else {
      throw new Error(appResponse.ErrorCodes.join(','));
    }
  }

  public async add(device: Device): Promise<boolean> {
    const MasterAccountId = this.MasterAccountId;
    const response: AxiosResponse<
      AppResponse<any>
    > = await AuthorizedApiClient.post('/device/create', {
      ...device,
      MasterAccountId,
    });
    const appResponse: AppResponse<any> = response.data;
    if (appResponse.IsSuccess) {
      return true;
    } else {
      throw new Error(appResponse.ErrorCodes.join(','));
    }
  }

  public async delete(PhoneNumber: string): Promise<boolean> {
    const MasterAccountId = this.MasterAccountId;
    const response: AxiosResponse<
      AppResponse<any>
    > = await AuthorizedApiClient.post('/device/Delete', {
      PhoneNumber,
      MasterAccountId,
    });
    const appResponse: AppResponse<any> = response.data;
    if (appResponse.IsSuccess) {
      return true;
    } else {
      throw new Error(appResponse.ErrorCodes.join(','));
    }
  }

  public async updateStatus(
    PhoneNumber: string,
    Status: DeviceStatus,
  ): Promise<boolean> {
    const MasterAccountId = this.MasterAccountId;
    const response: AxiosResponse<
      AppResponse<any>
    > = await AuthorizedApiClient.post('/device/ChangeStatus', {
      PhoneNumber,
      Status,
      MasterAccountId,
    });
    const appResponse: AppResponse<any> = response.data;
    if (appResponse.IsSuccess) {
      return true;
    } else {
      throw new Error(appResponse.ErrorCodes.join(','));
    }
  }

  public async updateName(PhoneNumber: string, Name: string): Promise<boolean> {
    const MasterAccountId = this.MasterAccountId;
    const response: AxiosResponse<
      AppResponse<any>
    > = await AuthorizedApiClient.post('/device/ChangeName', {
      PhoneNumber,
      Name,
      MasterAccountId,
    });
    const appResponse: AppResponse<any> = response.data;
    if (appResponse.IsSuccess) {
      return true;
    } else {
      throw new Error(appResponse.ErrorCodes.join(','));
    }
  }

  public async updateGroupIds(
    PhoneNumber: string,
    ToAdd: string[],
    ToRemove: string[],
  ): Promise<boolean> {
    const MasterAccountId = this.MasterAccountId;
    const response: AxiosResponse<
      AppResponse<any>
    > = await AuthorizedApiClient.post('/device/ChangeGroupIds', {
      PhoneNumber,
      ToAdd,
      ToRemove,
      MasterAccountId,
    });
    const appResponse: AppResponse<any> = response.data;
    if (appResponse.IsSuccess) {
      return true;
    } else {
      throw new Error(appResponse.ErrorCodes.join(','));
    }
  }

  public async assign(device: Device): Promise<boolean> {
    const MasterAccountId = this.MasterAccountId;
    const response: AxiosResponse<
      AppResponse<any>
    > = await AuthorizedApiClient.post('/device/AssignDeviceToAccount', {
      ...device,
      MasterAccountId,
    });
    const appResponse: AppResponse<any> = response.data;
    if (appResponse.IsSuccess) {
      return true;
    } else {
      throw new Error(appResponse.ErrorCodes.join(','));
    }
  }
}
